var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM2.44346 8C2.44346 11.0688 4.93121 13.5565 8 13.5565C11.0688 13.5565 13.5565 11.0688 13.5565 8C13.5565 4.93121 11.0688 2.44346 8 2.44346C4.93121 2.44346 2.44346 4.93121 2.44346 8Z",
    fill: "#FEECBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7622 3.72527C14.029 2.56544 13.0098 1.61368 11.8025 0.961479C10.5953 0.309274 9.24059 -0.0214542 7.86863 0.00107875C6.49666 0.0236117 5.15355 0.398649 3.96839 1.09015C2.78322 1.78164 1.79583 2.76635 1.10112 3.94964C0.406405 5.13293 0.0277227 6.47501 0.00146492 7.84691C-0.0247929 9.21881 0.302256 10.5744 0.951181 11.7834C1.60011 12.9924 2.54909 14.0142 3.70693 14.7505C4.86477 15.4869 6.19254 15.913 7.56264 15.988L7.6966 13.5413C6.74617 13.4893 5.82509 13.1936 5.02189 12.6828C4.2187 12.172 3.56039 11.4632 3.11023 10.6246C2.66007 9.78586 2.43319 8.84549 2.45141 7.8938C2.46962 6.94211 2.73232 6.01111 3.21424 5.19026C3.69616 4.36941 4.38111 3.68632 5.20327 3.20663C6.02542 2.72694 6.95713 2.46677 7.90887 2.45114C8.8606 2.43551 9.80035 2.66494 10.6378 3.11737C11.4753 3.56981 12.1823 4.23004 12.6909 5.03462L14.7622 3.72527Z",
    fill: "#CC5C08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfProgress);
export default __webpack_public_path__ + "static/media/halfProgress.d84758e424cf8032a0529d0f09dff44c.svg";
export { ForwardRef as ReactComponent };